import { render, staticRenderFns } from "./details.html?vue&type=template&id=ba8b7b50&external"
import script from "./details.js?vue&type=script&lang=js&external"
export * from "./details.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports